import React from 'react'

function DefaultTheme(props) {
    const { primaryColor = '#000000', secondaryColor = '#ffffff', font = 'Inter' } = props?.state || {};
    const fontFamily = font ? `${font}, sans-serif` : 'Inter, sans-serif';
    
    return (
        <div 
            className={` p-0 cursor-pointer transition-all duration-300 hover:shadow-lg  w-full h-full ${props.active ? 'border-blue-500 shadow-lg ' : ' hover:border-gray-200'}`}
            onClick={props.onClick}
        >
            {/* Theme Preview - matches screenshot layout 1 */}
            <div className="w-full h-full  overflow-hidden shadow-sm">
                <div className="flex h-full">
                    {/* Primary color accent bar */}
                    <div 
                        className="w-4 sm:w-6 md:w-8 flex-shrink-0" 
                        style={{ backgroundColor: primaryColor }}
                    />
                    {/* Secondary color content area */}
                    <div 
                        className="flex-1 flex items-center px-2 sm:px-3 md:px-4"
                        style={{ backgroundColor: secondaryColor }}
                    >
                        <span 
                            className="text-xs sm:text-sm font-bold tracking-wider truncate"
                            style={{ 
                                color: primaryColor,
                                fontFamily: fontFamily
                            }}
                        >
                            {props.title} {props.text}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

function StackedTheme(props) {
    const { primaryColor = '#000000', secondaryColor = '#ffffff', font = 'Inter' } = props?.state;
    const fontFamily = font ? `${font}, sans-serif` : 'Inter, sans-serif';
    
    return (
        <div 
            className={` p-0 cursor-pointer transition-all duration-300 hover:shadow-lg  w-full h-full ${props?.active ? 'border-blue-500 shadow-lg ' : ' hover:border-gray-200'}`}
            onClick={props.onClick}
        >
            {/* Theme Preview - matches screenshot layout 2 */}
            <div className="w-full h-full  overflow-hidden shadow-sm">
                <div className="flex flex-col h-full">
                    {/* Primary color title bar */}
                    <div 
                        className="px-2 sm:px-3 md:px-4 py-1 sm:py-2 flex-shrink-0"
                        style={{ backgroundColor: primaryColor }}
                    >
                        <span 
                            className="text-xs sm:text-sm font-bold tracking-wider truncate block"
                            style={{ 
                                color: secondaryColor,
                                fontFamily: fontFamily
                            }}
                        >
                            {props.title}
                        </span>
                    </div>
                    {/* Secondary color content area */}
                    <div 
                        className="px-2 sm:px-3 md:px-4 py-2 sm:py-3 flex-1 flex items-center"
                        style={{ backgroundColor: secondaryColor }}
                    >
                        <span 
                            className="text-xs sm:text-sm font-bold tracking-wider truncate"
                            style={{ 
                                color: primaryColor,
                                fontFamily: fontFamily
                            }}
                        >
                             {props.text}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

function RoundedTheme(props) {
    const { primaryColor = '#000000', secondaryColor = '#ffffff', font = 'Inter' } = props.state;
    const fontFamily = font ? `${font}, sans-serif` : 'Inter, sans-serif';
    
    return (
        <div 
            className={` p-0 cursor-pointer transition-all duration-300 hover:shadow-lg  w-full h-full ${props.active ? 'border-blue-500 shadow-lg ' : ' hover:border-gray-200'}`}
            onClick={props.onClick}
        >
            {/* Theme Preview - matches screenshot layout 3 */}
            <div className="w-full h-full  p-1 sm:p-2 md:p-3 flex items-center justify-center">
                <div 
                    className="rounded-full px-3 sm:px-4 md:px-6 py-2 sm:py-3 text-center w-full max-w-full"
                    style={{ backgroundColor: primaryColor }}
                >
                    <span 
                        className="text-xs sm:text-sm font-bold tracking-wider truncate block"
                        style={{ 
                            color: secondaryColor,
                            fontFamily: fontFamily
                        }}
                    >
                        {props.title}  {props.text}
                    </span>
                </div>
            </div>
        </div>
    )
}

const themes = {
    default: DefaultTheme,
    rounded: RoundedTheme,
    stacked: StackedTheme
}

export default function Themes(props) {
    const Theme = themes[props?.name] || DefaultTheme; // fallback to DefaultTheme
    
    return (
        <Theme 
            title={props.title || ''} 
            name={props.name}
            text={props.text } 
            onClick={props.onClick}
            active={props.active}
            state={props?.state || {}}
        />
    )
}
